import { LockedIcon } from '@sketchnote/icons';
import { Button } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import React from 'react';
import { useDocStore } from 'src/features/docs/stores/useDocStore';
import { useSetStateBlockEditorValues } from 'src/shared/hooks';

const { useCallback } = React;

export const PDFDownload = ({ disabled }: { disabled: boolean }) => {
  const router = useRouter();
  const docId = router.query.view as string;
  const { onDownloadPDF } = useSetStateBlockEditorValues({
    docId: router.query.view as string,
  });
  const docData = useDocStore(
    useCallback(
      (s) => {
        if (typeof docId === 'string') {
          return s.docs[docId];
        }
      },
      [docId]
    )
  );
  const exportThePDF = () => {
    if (docData?.data) {
      //to be changed
      onDownloadPDF(
        `/creation/export?creationId=${router.query.view as string}`,
        docData.data.title
      );
    }
  };

  return (
    <Button className="w-full justify-center" disabled={disabled} size="lg" onClick={exportThePDF}>
      Export
      {disabled && <LockedIcon className="ml-8" />}
    </Button>
  );
};
